import { autoMount } from '../../../utils/autoMount';
import { OperatingCompany } from '../../../components/pages/operatingCompany';

autoMount({ OperatingCompany });
